import { render, staticRenderFns } from "./CatalogHealth.vue?vue&type=template&id=26534353&scoped=true"
import script from "./CatalogHealth.vue?vue&type=script&lang=js"
export * from "./CatalogHealth.vue?vue&type=script&lang=js"
import style0 from "./CatalogHealth.vue?vue&type=style&index=0&id=26534353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26534353",
  null
  
)

export default component.exports